import { Box, Alert, Typography, Button } from '@mui/material';
import { useState } from 'react';

export const PdfPreview = ({
    src,
    name,
}: {
    src: string | undefined;
    name: string;
}) => {
    const [hasError, setHasError] = useState(false);

    if (hasError) {
        return (
            <Box sx={{ textAlign: 'center' }}>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    PDF preview is not available. Your browser may not support
                    PDF viewing.
                </Alert>
                <Typography variant="h6" gutterBottom>
                    {name}
                </Typography>
                <Button
                    variant="contained"
                    href={src ?? ''}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Open PDF in New Tab
                </Button>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%', height: '80vh' }}>
            <iframe
                src={src}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
                title={name}
                onError={() => setHasError(true)}
                onLoad={e => {
                    // Check if the iframe loaded successfully
                    const iframe = e.target as HTMLIFrameElement;
                    try {
                        // Try to access the iframe content to detect if PDF loaded
                        if (iframe.contentDocument?.title === '') {
                            // This might indicate a PDF loading issue
                            setTimeout(() => {
                                if (
                                    iframe.contentDocument?.body?.innerHTML ===
                                    ''
                                ) {
                                    setHasError(true);
                                }
                            }, 2000);
                        }
                    } catch (error) {
                        // Cross-origin restrictions might prevent access, which is normal for PDFs
                        // Don't set error in this case
                    }
                }}
            />
        </Box>
    );
};
